/**
 * TECHS の手配番号（受注No）— 画面側の正規化と判定。
 * 決まりの本体はサーバー（`services/tehai_no.py`）。ここは入力の手触りのためだけに
 * 同じ形を1か所で持つ（`/api/mfg/issue-reasons` が返す `pattern` があればそれを使う）。
 *
 * 形: 9桁 = [系列 0/3][年2桁][月 01-12][連番4桁]  例) 026100105
 */
export const TEHAI_PATTERN = '^[03]\\d{2}(0[1-9]|1[0-2])\\d{4}$';
export const TEHAI_LENGTH = 9;
export const TEHAI_HINT = 'TECHSの受注No（9桁・0または3で始まる）';

const ZEN = '０１２３４５６７８９';

export function normalizeTehai(value) {
  let s = String(value || '').replace(/[０-９]/g, (c) => String(ZEN.indexOf(c)))
    .replace(/[\s\u3000-]/g, '').replace(/ー/g, '');
  if (s.length === TEHAI_LENGTH - 1 && new RegExp(TEHAI_PATTERN).test(`0${s}`)) s = `0${s}`;
  return s;
}

/** 空文字なら null（required は呼び手が見る）。だめなら理由の文字列を返す。 */
export function tehaiError(value, { required = false, pattern = TEHAI_PATTERN, hint = TEHAI_HINT } = {}) {
  const no = normalizeTehai(value);
  if (!no) return required ? '手配番号を入力してください（製造使用・試作使用では必須です）' : null;
  if (!/^\d+$/.test(no)) return '手配番号は数字だけで入力してください';
  if (!new RegExp(pattern).test(no)) return `手配番号は${hint}です（例 026100105）`;
  return null;
}
